import { render, staticRenderFns } from "./UpdateRecipeModal.vue?vue&type=template&id=1079432d"
import script from "./UpdateRecipeModal.vue?vue&type=script&lang=js"
export * from "./UpdateRecipeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports